export function projectTablePrefName(input, project) { return input + "." + project; }
